import React from 'react';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Software Developer',
      image: '👩‍💻',
      text: 'JobFinder helped me land my dream job at a top tech company. The interface is intuitive and the job matching is spot on!',
      rating: 5
    },
    {
      name: 'Michael Chen',
      role: 'Data Scientist',
      image: '👨‍🔬',
      text: 'As a recent graduate, I found amazing internship opportunities through JobFinder. The platform made it so easy to apply.',
      rating: 5
    },
    {
      name: 'Emily Rodriguez',
      role: 'HR Manager',
      image: '👩‍💼',
      text: 'We\'ve hired several great developers through JobFinder. The quality of candidates is excellent and the platform is easy to use.',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-container">
        <div className="section-header">
          <h2 className="section-title">What People Say</h2>
          <p className="section-description">
            Don't just take our word for it - hear from our users
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-quote">
                <FaQuoteLeft />
              </div>
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="star-filled" />
                ))}
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.image}</div>
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

